const getEnvConfig = () => {
  const env = process.env.REACT_APP_ENV || 'development';

  return {
    env,
    apiUrl: process.env.REACT_APP_API_URL,
    appName: process.env.REACT_APP_NAME,
    isDevelopment: env === 'development',
    isStaging: env === 'staging',
    isProduction: env === 'production',
    debug: process.env.REACT_APP_DEBUG === 'true',
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  };
};


export const config = getEnvConfig();

export default config;
